import { React, useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { showRegisterLossBreakModalAction, showRegisterInWareHouseModalAction } from "redux/actions/stockAction";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import Pagination from "@material-ui/lab/Pagination";
// @material-ui/icons components
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

// core componentssrc
import componentStylesGeneric from "assets/theme/views/admin/generic";
import TableBackdrop from "components/Backdrops/TableBackdrop/TableBackdrop";
import GenericButton from "components/Buttons/GenericButton";
import { ArrayUtils } from "utils/array_utils";
import { titles, labels } from "resources/resources";

const useStylesGeneric = makeStyles(componentStylesGeneric);

const tableHead = [
  "Especialidade",
  "Província",
  "Armazém",
  "Nº Lotes",
  "Qtd. Total",
  "Qtd.Atribuída",
  "Stock",
  "Perdas",
  "",
];

function CardSearchResult(props) {
  const theme = useTheme();
  const intl = useIntl();
  const classes = useStylesGeneric();

  const [stocksList, setStocksList] = useState([]);

  useEffect(() => {
    if (!ArrayUtils.NullOrEmpty(props.stockState.result)) {
      setStocksList(props.stockState.result.data);
    } else {
      setStocksList([]);
    }
  }, [props.stockState.result]);

  const openRegisterInWarehouseModal = (category, provinceId, categoryId) => {
    props.showRegisterInWareHouseModal(true, category, provinceId, categoryId);
  };
  return (
    <Card classes={{ root: classes.cardRoot }}>
      <CardHeader
        classes={{
          title: classes.cardHeader,
          action: classes.cardHeaderAction,
        }}
        title={
          <div>
            <div className={classes.sideBySideDiv}>
              {intl.formatMessage(titles.Title_Admin_ProfessionalKits_StocksManagement_ResultSection)}
            </div>
            <div className={classes.sideBySideDiv + " " + classes.cardElementsCount}>
              {"("}
              {props.stockState?.total_records}
              {")"}
            </div>
          </div>
        }
      ></CardHeader>
      <TableContainer>
        <Box component={Table} alignItems="center" marginBottom="0!important">
          <TableHead>
            <TableRow>
              {tableHead.map((prop, key) => (
                <TableCell
                  key={key}
                  classes={{
                    root: classes.tableCellRoot + " " + classes.tableCellRootHead,
                  }}
                >
                  {prop}
                </TableCell>
              ))}
              <TableCell
                key="detailsCol"
                classes={{
                  root:
                    classes.tableCellRoot + " " + classes.tableCellRootHead + " " + classes.tableCellHeadStickyRight,
                }}
              >
                {intl.formatMessage(labels.Label_Generic_Details)}
              </TableCell>
            </TableRow>
          </TableHead>

          {stocksList !== undefined && stocksList.length > 0 && (
            <TableBody>
              {stocksList?.map((prop, key) => (
                <TableRow key={key}>
                  <TableCell classes={{ root: classes.tableCellRoot }}>{prop.categoryName}</TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>{prop.provinceName}</TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>{prop.warehouseName}</TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>{prop.noOfBatches}</TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>{prop.kitsTotal}</TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>{prop.kitsAttributed}</TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>{prop.availableKits}</TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>{prop.lostKits}</TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot }}>
                    <Box justifyContent="center" display="flex">
                      <GenericButton
                        typeSubmit={false}
                        color="tertiary"
                        size="small"
                        onClick={() => {
                          openRegisterInWarehouseModal(prop.categoryId, prop.provinceId, prop.warehouseId);
                        }}
                      >
                        Registar Lote
                      </GenericButton>
                    </Box>
                  </TableCell>
                  <TableCell classes={{ root: classes.tableCellRoot + " " + classes.tableCellBodyStickyRight }}>
                    <Tooltip title="Detalhes">
                      <IconButton aria-label="details" component={Link} to={`/admin/stock-detail/${prop.id}`}>
                        <Box
                          component={ArrowForwardIosIcon}
                          width="12px!important"
                          height="12px!important"
                          color={theme.palette.primary.main}
                        />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Box>

        {(stocksList == null || stocksList.length === 0) && !props.stockState.searchStocks_loading && (
          <Box className={classes.noResultsInfoInTable}>Não existem resultados disponíveis.</Box>
        )}
      </TableContainer>

      <TableBackdrop open={props.stockState.searchStocks_loading} />

      <Pagination
        className={classes.alignPagination}
        count={props.stockState?.total_pages}
        page={props.page}
        onChange={props.handleChangePage}
        color="primary"
      ></Pagination>
    </Card>
  );
}

const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  showRegisterLossBreakModal: (toShow, category, batchNumber) =>
    dispatch(showRegisterLossBreakModalAction(toShow, category, batchNumber)),
  showRegisterInWareHouseModal: (toShow, category, provinceId, categoryId) =>
    dispatch(showRegisterInWareHouseModalAction(toShow, category, provinceId, categoryId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CardSearchResult);
